/** Formatting carrier: retain the supplied clock fields, never infer a historical time zone. */
export function storedDateForDisplay(value: string | number | Date): Date {
  if (typeof value === 'string') {
    const iso = value.match(/^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)(?:Z|[+-]\d{2}:?\d{2})?)?$/);
    if (iso) {
      return new Date(`${iso[1]}T${iso[2] || '00:00:00'}Z`);
    }
  }
  // Date-picker values and numeric calendar values carry local calendar fields.
  const date = value instanceof Date ? value : new Date(value);
  const fields = new Date(0);
  fields.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  fields.setUTCHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  return fields;
}
